import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
  });
}

if (environment.production) {
  enableProdMode();
}

// As of Angular 21, `PlatformRef.bootstrapModuleFactory` prepends
// `provideZonelessChangeDetectionInternal()` to the app providers, so ZONELESS change
// detection is now the DEFAULT — even for NgModule bootstrap with Zone.js loaded in
// polyfills. This codebase is written for Zone.js-based CD: it mutates plain fields on
// shared models (`paging.loading`, service subjects fed by Firestore listeners, …) from
// async callbacks without marking views dirty. Under zoneless those writes leave the
// consuming views stale, and dev-mode `checkNoChanges` — which walks the WHOLE tree,
// unlike the refresh pass that only visits dirty subtrees — then reports NG0100 all over
// the app. `provideZoneChangeDetection()` restores the previous behaviour (it sets
// ZONELESS_ENABLED=false and a real NgZone).
//
// It MUST go through `applicationProviders` here, not AppModule's `providers`: the
// zoneless defaults are applied as app providers and would win over the module's, and
// Angular explicitly guards against `provideZoneChangeDetection()` in a bootstrapModule
// NgModule (see the PROVIDED_NG_ZONE token).
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch(err => console.error(err));
